import React from 'react';
import { appIcon } from 'src/assets';

export const ComplexUserInfoTag: React.FC<{label: string}> = ({ label }) => (
  <>
    <img src={appIcon.iconInfo.default} alt="icon info" />
    <span
      role="img"
      aria-label="img"
    >
      {label}
    </span>
  </>
);
